const en = {
  "User": "User",
  "Password": "Password",
  "Login": "Login",
  "Oversea Return Service": "Oversea Return Service",
  "Save": "Save",
  "Order ID": "Order ID",
  "Order ID(optional)": "Order ID(optional)",
  "Delivery tracking number(optional)": "Delivery tracking number(optional)",
  "Delivery tracking number": "Delivery tracking number",
  "Notes": "Notes(optional)",
  "Upload Image": "Upload Image",
  "Product Images": "Product Images*",
  "Is product damaged?": "Is product damaged?",
  "Yes": "Yes",
  "No": "No",
  "Warehouse": "Warehouse",
  "Merchant": "Merchant",
  "Store Id: {n}": "Store Id: {n}",
  "Latest return requests": "Latest return requests",
  "requested": "requested",
  "Requested": "Requested",
  "Create a new return request": "Create a new return request",
  "Warehouse Location": "Warehouse Location",
  "Return Details": "Return Details",
  "New return request": "New return request",
  "Pick a warehouse": "Pick a warehouse",
  "Quantity": "Quantity",
  "Return Quantity": "Return Quantity",
  "Actual paid amount": "Actual paid amount",
  "refund": "refund",
  "Delete": "Delete",
  "Returned": "Returned",
  "Refunded": "Refunded",
  "Warehouse Records": "Warehouse Records",
  "Back": "Back",
  "Customer service": "Customer service",
  "Incomplete returns": "Incomplete returns",
  "Warehouse record": "Warehouse record",
  "This record doesn't have a match in any return request": "This record doesn't have a match in any return request",
  "Link to": "Link to return request",
  "Product name": "Product name",
  "Product descripotion": "Product descripotion",
  "Product ID": "Product ID",
  "Sorry. You don't have permission to access this page.": "Sorry. You don't have permission to access this page.",
  "No Permission": "No Permission",
  "New return item": "New return item",
  "Return items": "Return items",
  "Close": "Close",
  "Save changes": "Save changes",
  "Cancel delete": "Cancel delete",
  "You don't have any return requests": "You don't have any return requests",
  "user does not exist": "User does not exist",
  "Error": "Error",
  "Success": "Success",
  "Please fill the correct information!": "Please fill the correct information!",
  "Result not found": "Result not found",
  "Warehouse Record created!": "Warehouse Record created!",
  "Please upload at least one image!": "Please upload at least one image!",
  "congratulations! No incomplete return requests!": "congratulations! No incomplete return requests!",
  "Received at warehouse": "Received at warehouse",
  "Issued refund": "Issued refund",
  "returned": "Received at warehouse",
  "refunded": "Issued Refund",
  "Approve": "Approve",
  "approved": "Approved",
  "Item not found!": "Item not found!",
  "This item is damaged": "This item is damaged",
  "This item is in good condition": "This item is in good condition",
  "Logout": "Logout",
  "Changes has been saved!": "Changes has been saved!",
  "password not match": "Password not match",
  "Please key in a valid Taobao order id.": "Please key in a valid Taobao order id.",
  "Page not found!": "Page not found!",
  "Do you confirm to delete this record?": "Do you confirm to delete this record?",
  "No warehouse records yet. Be patient.": "No warehouse records yet. Be patient.",
  "Home": "Home",
  "Welcome!": "Welcome!",
  "Taobao order id": "Taobao order id",
  "Not saved": "Not saved",
  "Edit": "Edit",
  "Created Date": "Created Date",
  "Taobao ID": "Taobao ID",
  "Taobao order ID already exist": "Taobao order ID already exist",
  "Decline": "Decline",
  "Change status to": "Change status to",
  "decline": "Decline",
  "Change password": "Change password",
  "Current password": "Current password",
  "New password": "New password",
  "Repeat new password": "Repeat new password",
  "Fields cannot be empty!": "Fields cannot be empty!",
  "New password doesn't match!": "New password doesn't match!",
  "Change password failed": "Change password failed",
  "Internal Server Error": "Internal Server Error",
  "Successfully updated your password!": "Successfully updated your password!",
  "Password does not match.": "Password does not match.",
  "New password cannot be the same as current password!": "New password cannot be the same as current password!",
  "Something went wrong.": "Something went wrong.",
  "Passwords must be at least 8 characters long!": "Passwords must be at least 8 characters long!",
  "Comments": "Comments",
  "Comment": "Comment",
  "commented on": "commented on",
  "Send to merchant": "Send to merchant",
  "Confirm send this image to the merchant?": "Confirm send this image to the merchant?",
  "Comment cannot be empty!": "Comment cannot be empty!",
  "taobao": "Taobao",
  "zhongan": "Zhongan",
  "slab": "SLab",
  "Start Date": "Start Date",
  "End Date": "End Date",
  "Search query or start date and end date must not be empty!": "Search query or start date and end date must not be empty!",
  "Taobao Status": "Taobao Status",
  "Taobao Return Warehouse Id": "Taobao Return Warehouse Id",
  "Taobao Parent Order Id": "Taobao Parent Order Id",
  "Taobao Return Tracking Number": "Taobao Return Tracking Number",
  "Taobao Claim Number": "Taobao Claim Number",
  "Please pick a date": "Please pick a date",
  "Please choose": "Please choose",
  "created": "created",
  "Created": "Created",
  "Not Received": "Not Received",
  "Affect resell": "Affect resell",
  "Received in good condition": "Received in good condition",
  "Received wrong item": "Received wrong item",
  "All": "All",
  "Return status": "Return status",
  "Please choose a status": "Please choose a status",
  "Please select": "Please select",
  "Claim": "Claim",
  "Update": "Update",
  "Policy Id": "Axinan Ref",
  "Taobao Order Id": "Taobao Order Id",
  "Store Name": "Store Name",
  "Submitted on": "Submitted on",
  "Coverage": "Coverage",
  "Category": "Category",
  "Product Name": "Product Name",
  "Unit Price": "Unit Price",
  "Order Date": "Order Date",
  "Product Property": "Product Property",
  "Update": "Update",
  "Status": "Status",
  "Delivery Tracking Number": "Tracking Number",
  "Claim Number": "Claim Number",
  "Return Reason": "Return Reason",
  "Return Remarks": "Return Remarks",
  "Updated successfully": "Updated successfully",
  "Merchant Name": "Merchant Name",
  "Parent Order Id": "Parent Order Id",
  "Suborder Id": "Suborder Id",
  "Product Name": "Product Name",
  "Unit Price": "Unit Price",
  "Delivery tracking number": "Delivery tracking number",
  "Claim Amount": "Claim Amount",
  "Claim Status": "Claim Status",
  "No records has been found! Please choose another date or use another id.": "No records has been found! Please choose another date or use another id.",
  "Return records": "Return records",
  "Paid Amount": "Paid Amount",
  "The date range must be within 70 days!": "The date range must be within 70 days!",
  "Return Submitted Date": "Return Submitted Date",
  "Order Created at": "Order Created at",
  "resell": "Resell",
  "Axinan Internal Product Id": "Axinan Internal Product Id",
  "Stock In": "Stock In",
  "Search": "Search",
  "We haven't receive any data about this package! Please check a few days later!": "We haven't receive any data about this package! Please check a few days later!",
  "Please key in the delivery tracking number on the package.": "Please key in the delivery tracking number on the package.",
  "Note": "Note",
  "Create New Inventory Item": "Create New Inventory Item",
  "Inventory Items": "Inventory Items",
  "unreceived packages": "Unreceived packages",
  "Scan": "Scan",
  "Create Staging Record": "Create Staging Record",
  "We can't find this tracking number in our system, please create a staging record first!": "We can't find this tracking number in our system, please create a staging record first!",
  "Tracking Number": "Tracking Number",
  "Shelf Id": "Shelf Id",
  "Customer Name": "Customer Name",
  "Customer Phone Number": "Customer Phone Number",
  "Staging Records": "Staging Records",
  "Received without info": "Received without info",
  "Ready to stock in": "Ready to stock in",
  "Completed": "Completed",
  "Price": "Price",
  "lastUpdateAt": "Last updated on",
  "20": "User doesn't not exist",
  "21": "User name and password doesn't match",
  "22": "No permission",
  "23": "Login failed",
}

export default en



// WEBPACK FOOTER //
// ./src/translations/en.js